import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24376c74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert__content" }
const _hoisted_2 = {
  key: 0,
  class: "alert__title"
}
const _hoisted_3 = {
  key: 1,
  class: "alert__message"
}
const _hoisted_4 = {
  key: 2,
  class: "alert__message"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "gg-close" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["alert", 'alert--' + _ctx.type])
  }, [
    _createVNode(_component_BaseSvg, {
      class: "icon",
      icon: 'status/' + _ctx.type
    }, null, 8, ["icon"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.message), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]))
    ]),
    (_ctx.closable)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          class: "close"
        }, _hoisted_6))
      : _createCommentVNode("", true)
  ], 2))
}